/**
 * Extract STUN/TURN server hostnames for telemetry — credentials are
 * intentionally excluded.
 */
export const extractIceServerUrls = (servers: RTCIceServer[]): string =>
  servers
    .flatMap((s) => (Array.isArray(s.urls) ? s.urls : [s.urls]))
    .map((u) => u.replace(/^(stun|turn|turns):\/\//, '').split('?')[0])
    .join(',');
